import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, firstValueFrom, of, takeUntil, timeout } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AgGridTableService } from '../../services/ag-grid.service';
import { ApiCallsService } from '../../services/api-calls.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ToastService } from '../../services/toast.service';
@Injectable({
  providedIn: 'root'
})
export class ModalsPaginationService {

  private payload: any | null = null;
  private reportKey!: string;

  private currentPage = 1;
  private limit = 10;          // default limit
  private offset = 0;          // default offset
  private totalCount = 0;
  private fullListData: any[] = [];

  totalCount$ = new BehaviorSubject<number>(0);
  payloadChanged$ = new BehaviorSubject<boolean>(false);
  private mapByUrlCache = new Map<string, any>();

  constructor(
    private api: ApiCallsService,
    private aggrid: AgGridTableService,
    private http:HttpClient,
    private toast: ToastService
    
  ) {}
  ModalTitle:string = ''
  /** Initial load */
initFilters(
  payload: any,
  reportKey: string,
  destroy$: any,
  modalTitle:string =''
) {
  this.ModalTitle = modalTitle
  console.log(this.ModalTitle);
  
  const payloadChanged =
    this.isPayloadChanged(this.payload, payload) 

  this.payloadChanged$.next(payloadChanged);

  if (payloadChanged) {
    this.reset();
  }
  if (reportKey ==='') {
    return
  }
  this.payload = {...payload,Limit:this.limit,Offset:this.offset}
  this.reportKey = reportKey;
  this.fetchPage(destroy$);
}


  /** Pagination handler (component stays unchanged) */
  changePage(
    event: { page: number; pageSize: number },
    destroy$: any
  ) {
    this.currentPage = event.page;
    this.limit = event.pageSize;
    console.log(event);
    this.payload.Limit = this.limit
    // ✅ correct offset calculation 
    this.offset = (this.currentPage - 1) * this.limit;
    this.payload.Offset = this.offset

    if (this.offset >= this.totalCount && this.totalCount > 0) return;

    this.fetchPage(destroy$);
  }

  /** Reset */
  reset() {
    this.totalCount$.next(0);
    this.fullListData = [];
    this.currentPage = 1;
    this.offset = 0;
    this.totalCount = 0;
    this.payload = []
    this.reportKey =''
    this.aggrid.processTableDataModal([]);
    // this.ModalTitle = ''
  }

  // ---------------- PRIVATE ---------------- //

  private fetchPage(destroy$: any) {
    console.log(this.payload);
    this.api.getPopupAPI(
      this.reportKey,
      this.payload
    )
    .pipe(takeUntil(destroy$))
    .subscribe({
      next: (data) => this.processResponse(data),
      error: (err) => {
        console.error(err.error.Message);
        this.aggrid.processTableDataModal([]);
      }
    });
  }

  private processResponse(data: any) {

    const list = data.Data.list || [];
    this.totalCount = Number(data.Data.total||data.Data.count);
    this.totalCount$.next(this.totalCount);

    // Ensure full list size for AgGrid virtual pagination
    while (this.fullListData.length < this.totalCount) {
      this.fullListData.push({
        id: `dummy-${this.fullListData.length}`,
        isDummy: true
      });
    }

    // Replace slice using offset
    list.forEach((item: any, i: number) => {
      const index = this.offset + i;
      if (index < this.totalCount) {
        this.fullListData[index] = { ...item, isDummy: false };
      }
    });
    console.log(this.ModalTitle);
    
    this.aggrid.processTableDataModal({
      ...data,
      Data: {
        ...data.Data,
        list: [...this.fullListData]
      },
      
    },'',false,this.ModalTitle);
  }

private isPayloadChanged(
  oldPayload: any,
  newPayload: any
): boolean {
  if (!oldPayload) return true;

  const keys = new Set([
    ...Object.keys(oldPayload),
    ...Object.keys(newPayload)
  ]);

  for (const key of keys) {
    if (oldPayload[key] !== newPayload[key]) {
      return true;
    }
  }

  return false;
}
sitename:string = ''
downloadCSV(destroy$: any,showtrue:any[]=[],sitename:string ='') {
  if (!this.payload || !this.reportKey) {
    console.warn('CSV download aborted: payload not initialized');
    return;
  }

  this.sitename = sitename
  const limitForCSV = this.totalCount > 0 ? this.totalCount : 10000;
  const payloaddownload :any = {...this.payload}
  payloaddownload.Limit = limitForCSV
  payloaddownload.Offset = 0
  this.api.getPopupAPI(
      this.reportKey,
      payloaddownload
  )
  .pipe(takeUntil(destroy$))
  .subscribe({
    next: (data) => this.handleCSVResponse(data,showtrue),
    error: (err) => console.error('❌ CSV download failed:', err)
  });
}

private filterHeadersByVisibility(headers: any[], showtrue: any[]) {
  if (!Array.isArray(showtrue) || !showtrue.length) return headers;

  const visibleFields = new Set(
    showtrue
      .filter(col => col.hide === false)
      .map(col => col.field)
  );

  return headers.filter((h: any) =>
    visibleFields.has(h.key) // h.key must match field
  );
}
private filterRowDataByHeaders(list: any[], headers: any[]) {
  const allowedKeys = new Set(headers.map((h: any) => h.key));

  return list.map(row => {
    const filtered: any = {};
    for (const key of allowedKeys) {
      filtered[key] = row[key];
    }
    return filtered;
  });
}


async applyHeaderUrlMappingsForExport(
  headers: any[],
  rows: any[],
): Promise<any[]> {

  if (!headers?.length || !rows?.length) {
    return rows;
  }

  const urlHeaders = headers.filter(h =>
    h?.key && h?.MapByUrl && h?.MapByKey && h?.MapByValue
  );

  if (!urlHeaders.length) {
    return rows;
  }

  let updatedRows = [...rows];
  const encodedSite = localStorage.getItem('site_idLogin');
    const rawSite = this.payload?.site_ids || this.payload?.site_id || rows[0]?.site_id || rows[0]?.siteid || (encodedSite ? atob(encodedSite) : '');
    const siteIds: string[] = String(rawSite || '')
      .split(',')
      .map((s: string) => s.trim())
      .filter(Boolean);

    for (const header of urlHeaders) {
      const cleanUrl = header.MapByUrl?.replace(/^\/+/, '') || '';
      const payloadKeyStr = header.MapByPayload ? JSON.stringify(header.MapByPayload) : '';
      const cacheKey = `${cleanUrl}_${siteIds.sort().join('_')}_${payloadKeyStr}`;
      let lookup: Record<string, any> = {};

      try {
        // ---------- CACHE ----------
        if (this.mapByUrlCache.has(cacheKey)) {
          lookup = this.mapByUrlCache.get(cacheKey);
        }
        // ---------- API ----------
        else {
          let extraParams: any = {};
          if (header.MapByPayload && typeof header.MapByPayload === 'object') {
            extraParams = { ...header.MapByPayload };
          }

          const mapByKey = typeof header.MapByKey === 'string' ? header.MapByKey : 'id';
          const mapByValue = header.MapByValue || 'name';

          const sitesToCall = siteIds.length > 0 ? siteIds : [''];
          const responses = await Promise.all(
            sitesToCall.map(siteId => {
              const params: any = { Limit: 10000, Offset: 0, ...extraParams };
              if (siteId) {
                params.site_id = siteId;
              }
              return firstValueFrom(
                this.http
                  .get<any>(`${environment.apiURL}/${cleanUrl}`, { params })
                  .pipe(
                    timeout(8000),
                    catchError(() => of(null))
                  )
              );
            })
          );

          lookup = responses.reduce((acc: any, res: any) => {
            const list = res?.Data?.list ?? res?.Data ?? res ?? [];
            if (!Array.isArray(list)) return acc;

            list.forEach((item: any) => {
              const key = item[mapByKey];
              const value = item[mapByValue];
              if (key != null && value != null) {
                acc[key] = value;
                acc[String(key)] = value;
              }
            });
            return acc;
          }, {});

          this.mapByUrlCache.set(cacheKey, lookup);
        }

        // ---------- APPLY ----------
        if (!Object.keys(lookup).length) {
          continue;
        }

        updatedRows = updatedRows.map(row => {
          const val = row[header.key];
          if (val != null) {
            const mapped = lookup[val] ?? lookup[String(val)];
            return {
              ...row,
              [header.key]: mapped !== null && mapped !== undefined ? mapped : (val === '' || val === '---' ? '---' : val)
            };
          }
          return row;
        });

      } catch (err) {
        console.error(`Failed to map ${header.key} from URL ${cleanUrl}:`, err);
        continue;
      }
    }

    return updatedRows;
}

private async handleCSVResponse(data: any, showtrue: any[] = []) {
  if (data?.Status !== 'Success') return;

  let headers = data?.Data?.header || [];
  let list = data?.Data?.list || [];

  if (!headers.length || !list.length) return;

  /* ----------------------------------------
     Fix sitename column (unchanged)
     ---------------------------------------- */
  const siteNameHeader = headers.find(
    (h: any) => h.key === 'site_name' && h.show === true
  );

  if (siteNameHeader) {
    const siteList = JSON.parse(localStorage.getItem('siteList') || '[]');
    if (Array.isArray(siteList) && siteList.length) {
      const siteMap = new Map(
        siteList.map((s: any) => [String(s.site_id), s.site_name])
      );

      list = list.map((row: any) => {
        if (!row.site_name && row.site_id) {
          return {
            ...row,
            site_name: siteMap.get(String(row.site_id)) || ''
          };
        }
        return row;
      });
    }
  }

  /* ----------------------------------------
     Apply header mappings
     ---------------------------------------- */
  list = this.aggrid.applyHeaderKeyMappings(headers, list) || [];
  if (!list.length) return;
  list = await this.applyHeaderUrlMappingsForExport(
    headers,
    list,
  );
  /* ----------------------------------------
     🔑 NEW: Apply hide/show logic
     ---------------------------------------- */
  headers = this.filterHeadersByVisibility(headers, showtrue);
  list = this.filterRowDataByHeaders(list, headers);

  if (!headers.length || !list.length) return;

  const csv = this.convertToCSVUsingHeader(headers, list);

  const fileName = `${this.sitename}.csv`;
  this.triggerCSVDownload(csv, fileName);
}

private convertToCSVUsingHeader(
headers: Array<{ name: string; key: string}>
,  data: any[]
): string {

  // 🔥 Filter out siteid column from CSV output
const validHeaders = headers.filter(h =>
  h.key?.toLowerCase() !== 'siteid'
);


  /* --------------------------------------------------
     🔹 Build site lookup map from localStorage
     -------------------------------------------------- */
  const siteList = JSON.parse(localStorage.getItem('siteList') || '[]');

  const siteMap = new Map<string, any>();
  siteList.forEach((s: any) => {
    if (s.site_id) {
      siteMap.set(String(s.site_id), s);
    }
  });

  // CSV header row
  const headerRow = validHeaders
    .map(h => `"${h.name}"`)
    .join(',');

  // CSV data rows
  const rows = data.map(row =>
    validHeaders
      .map(h => {
        let value = row[h.key];

        /* --------------------------------------------
           🔹 Fallback mapping for site_name / short_code
           -------------------------------------------- */
        if (
          (value === undefined || value === null || value === '') &&
          row.siteid &&
          (h.key === 'site_name' || h.key === 'short_code')
        ) {
          const site = siteMap.get(String(row.siteid));
          value = site?.[h.key] ?? '';
        }

        return `"${String(value ?? '').replace(/"/g, '""')}"`;
      })
      .join(',')
  );

  return [headerRow, ...rows].join('\n');
}

private triggerCSVDownload(csv: string, filename: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.click();

  URL.revokeObjectURL(url);
}
// downloadPDF(destroy$: any, showtrue: any[] = []) {
//   if (!this.payload || !this.reportKey) {
//     console.warn('PDF download aborted: payload not initialized');
//     return;
//   }

//   const pageSizeForPDF = this.totalCount > 0 ? this.totalCount : 10000;
//   const payloaddownload :any = {...this.payload}
//   payloaddownload.Limit = pageSizeForPDF
//   payloaddownload.Offset = 0
//   this.api.getPopupAPI(
//       this.reportKey,
//       payloaddownload
//   )
//   .pipe(takeUntil(destroy$))
//   .subscribe({
//     next: (data) => this.handlePDFResponse(data, showtrue),
//     error: (err) => {
//       console.error('❌ PDF download failed:', err);
//       this.toast.showToast('PDF download failed: ' + err, 'colored', 5000, 'danger');
//     }
//   });
// }

// private async handlePDFResponse(data: any, showtrue: any[] = []) {
//   if (data?.Status !== 'Success') return;

//   let headers = data?.Data?.header || [];
//   let list = data?.Data?.list || [];

//   if (!headers.length || !list.length) return;

//   /* ---------------- Site Name Fix ---------------- */
//   const siteNameHeader = headers.find(
//     (h: any) => h.key === 'site_name' && h.show === true
//   );

//   if (siteNameHeader) {
//     const siteList = JSON.parse(localStorage.getItem('siteList') || '[]');
//     if (Array.isArray(siteList) && siteList.length) {
//       const siteMap = new Map(
//         siteList.map((s: any) => [String(s.site_id), s.site_name])
//       );

//       list = list.map((row: any) => {
//         if (!row.site_name && row.site_id) {
//           return {
//             ...row,
//             site_name: siteMap.get(String(row.site_id)) || ''
//           };
//         }
//         return row;
//       });
//     }
//   }

//   /* ---------------- Apply Key Mapping ---------------- */
//   list = this.aggrid.applyHeaderKeyMappings(headers, list) || [];
//   if (!list.length) return;

//   list = await this.applyHeaderUrlMappingsForExport(headers, list);

//   /* ---------------- Apply Hide/Show ---------------- */
//   headers = this.filterHeadersByVisibility(headers, showtrue);
//   list = this.filterRowDataByHeaders(list, headers);

//   if (!headers.length || !list.length) return;

//   this.generatePDF(headers, list);
// }
// private generatePDF(
//   headers: Array<{ name: string; key: string; show?: boolean }>,
//   data: any[]
// ) {
//   this.setSiteNameFromStorage()
//   const validHeaders = headers.filter(h =>
//     h.key?.toLowerCase() !== 'siteid' &&
//     h.show !== false
//   );

//   const doc = new jsPDF({
//     orientation: 'landscape'
//   });

//   const pageWidth = doc.internal.pageSize.getWidth();

//   /* =====================================================
//      ✅ HEADER SECTION
//   ===================================================== */

//   const payload = this.payload || {};

//   const BLACKLIST = ['offset', 'limit', 'site_id','site_ids'];

//   const runDate = new Date().toLocaleString();

//   // ----- LEFT SIDE -----
//   doc.setFontSize(10);
//   doc.setFont('helvetica', 'bold');

//   doc.text(`Site : ${this.sitename||'-'}`, 14, 10);

//   // ----- CENTER TITLE -----
//   doc.setFontSize(14);
//   doc.setFont('helvetica', 'bold');
//   doc.text(
//     this.formatKey(this.downloadheader),
//     pageWidth / 2,
//     12,
//     { align: 'center' }
//   );

//   // ----- RIGHT SIDE -----
//   doc.setFontSize(9);
//   doc.setFont('helvetica', 'normal');

//   doc.text(`Page 1 of 1`, pageWidth - 14, 10, { align: 'right' });
//   doc.text(`Run Date : ${runDate}`, pageWidth - 14, 16, { align: 'right' });

//   /* =====================================================
//      ✅ FILTER ROW (From / To etc)
//   ===================================================== */

//   let filterY = 24;
//   doc.setFontSize(9);

//   Object.entries(payload).forEach(([key, value]) => {
//     if (BLACKLIST.includes(key.toLowerCase())) return;
//     if (!value) return;

//     const label = this.formatKey(key);

//     doc.text(`${label} : ${value}`, 14, filterY);
//     filterY += 6;
//   });

//   // Divider line
//   doc.line(10, filterY, pageWidth - 10, filterY);

//   /* =====================================================
//      ✅ TABLE
//   ===================================================== */

//   const tableHeaders = validHeaders.map(h => h.name);

//   const tableRows = data.map(row =>
//     validHeaders.map(h => row[h.key] ?? '')
//   );

//   autoTable(doc, {
//     head: [tableHeaders],
//     body: tableRows,
//     startY: filterY + 5,
//     styles: {
//       fontSize: 8,
//       cellPadding: 3,
//       valign: 'middle'
//     },
//     headStyles: {
//       fillColor: [230, 230, 230],
//       textColor: 0,
//       lineWidth: 0.2
//     },
//     theme: 'grid',
//     margin: { left: 10, right: 10 }
//   });

//   doc.save(`${this.formatKey(this.downloadheader)}.pdf`);
// }
// private formatKey(key: string): string {
//   const customLabels: Record<string, string> = {
//     unit_from: 'From Unit',
//     unit_to: 'To Unit',
//     from_unit: 'From Unit',
//     to_unit: 'To Unit',
//     unit: 'Unit',
//     search: 'Search By',
//     search_by: 'Search By',
//     searchby: 'Search By',
//     filter_search: 'Search By',
//     filtersearch: 'Search By',
//     search_text: 'Search By',
//     searchtext: 'Search By',
//     search_term: 'Search By',
//     searchterm: 'Search By',
//     search_val: 'Search By',
//     searchval: 'Search By',
//     search_value: 'Search By',
//     searchvalue: 'Search By',
//     search_query: 'Search By',
//     searchquery: 'Search By',
//     search_input: 'Search By',
//     searchinput: 'Search By'
//   };
//   const lower = key.toLowerCase();
//   if (customLabels[lower]) {
//     return customLabels[lower];
//   }
//   if (lower === 'search' || lower.startsWith('search') || lower.endsWith('search') || lower.includes('_search') || lower.includes('search_')) {
//     return 'Search By';
//   }
//   return key
//     .toLowerCase()
//     .replace(/[_-]+/g, ' ')
//     .replace(/\b\w/g, c => c.toUpperCase());
// }

// private setSiteNameFromStorage(): void {

//   let siteIdsRaw: string | null = this.payload?.site_ids || null;
//   const siteListRaw = localStorage.getItem('siteList');
//   if (!siteListRaw) {
//     this.sitename = '';
//     return;
//   }

//   try {
//     const siteList = JSON.parse(siteListRaw);

//     // ✅ fallback if empty
//     if (!siteIdsRaw) {
//       const encoded = localStorage.getItem('site_idLogin');
//       siteIdsRaw = encoded ? atob(encoded) : null;
//     }

//     if (!siteIdsRaw) {
//       this.sitename = '';
//       return;
//     }

//     // ✅ normalize ids
//     const siteIds = String(siteIdsRaw)
//       .split(',')
//       .map(id => id.trim())
//       .filter(Boolean);

//     // ✅ find matches
//     let matchedSites = siteList.filter((site: any) =>
//       siteIds.includes(String(site.site_id))
//     );

//     // ✅ fallback if no match found
//     if (matchedSites.length === 0) {
//       const encoded = localStorage.getItem('site_idLogin');
//       const decoded = encoded ? atob(encoded) : null;

//       if (decoded) {
//         matchedSites = siteList.filter((site: any) =>
//           String(site.site_id) === decoded
//         );
//       }
//     }

//     const matchedNames = matchedSites.map((site: any) => site.site_name);

//     // ✅ final display
//     this.sitename =
//       matchedNames.length > 3
//         ? `${matchedNames.slice(0, 3).join(', ')} +${matchedNames.length - 3} more`
//         : matchedNames.join(', ');

//   } catch (e) {
//     console.error('Invalid siteList in localStorage');
//     this.sitename = '';
//   }
// }

}
